jQuery(function ($) {
	new Swiper($('.portfolio__slider .swiper')[0], {
		slidesPerView: 1,
		grabCursor: true,
		speed: 700,
		loop: true,
		navigation: {
			nextEl: $('.swiper-arrow.next')[0],
			prevEl: $('.swiper-arrow.prev')[0],
		},
	});
});
